/** Oidc section imports */
import { createUserManager } from 'redux-oidc';
import { getAbsoluteUrlAddresss } from './UrlHelper'

/**
 * =============================================================================
 * IS4 OIDC CONFIGURATION — Flujo de autenticación Identity Server 4
 * =============================================================================
 *
 * Endpoints IS4 del flujo de autenticación (base: REACT_APP_IDENTITY_SERVER):
 *
 *   GET  .well-known/openid-configuration
 *        Discovery document — oidc-client lo consulta automáticamente al inicializar
 *
 *   GET  connect/authorize
 *        Inicio de sesión — redirige al usuario al login de IS4
 *        Parámetros clave: client_id='sip20_web_app', response_type='id_token token',
 *        scope='openid profile userprofile'
 *
 *   POST connect/token
 *        Intercambio de código por access_token + id_token (gestionado por oidc-client)
 *
 *   GET  connect/userinfo
 *        Claims del usuario autenticado. Scope 'userprofile' (custom IS4) expone:
 *          user_type         → 'InternalUser' | 'ExternalUser'
 *          user_name         → username IS4 (reemplaza 'username' sin guión bajo de IS3)
 *          company_code      → código de empresa (usuarios externos)
 *          company_token     → token de empresa (usuarios externos)
 *          sub               → identificador único del usuario
 *          preferred_username → presente en PTM-IS4; no garantizado en otras instancias IS4
 *
 *   GET  connect/endsession
 *        Cierre de sesión — invocado por redux-oidc al hacer signOut
 *
 * Cambios SP-214:
 *   - Scope 'userprofile' documentado: expone claims de negocio IS4
 *   - authority: trailing slash eliminado para evitar double-slash en URLs IS4
 *   - monitorSession: false (evita polling de sesión innecesario)
 *
 * Usuarios externos (proveedores): ver ExternalUserActions.js
 * Usuarios internos: ver InternalActions.js
 * =============================================================================
 */

/** Defines the user manager configuration */
const userManagerConfig = {
  client_id: 'sip20_web_app',
  redirect_uri: getAbsoluteUrlAddresss('callback'),
  post_logout_redirect_uri: getAbsoluteUrlAddresss(''),
  response_type: 'id_token token',
  // userprofile: scope custom de IS4 que expone los claims de negocio user_type, user_name, company_code, company_token
  scope: 'openid profile userprofile',
  authority: (process.env.REACT_APP_IDENTITY_SERVER || '').replace(/\/$/, ''),
  filterProtocolClaims: true,
  loadUserInfo: true,
  clockSkew: 900,
  monitorSession: false
};

const userManager = createUserManager(userManagerConfig);
export default userManager;